import jwtDecode from 'jwt-decode';
import { AUTH_ACCESS_TOKEN, AUTH_REFRESH_TOKEN } from './constants';

export const constructUser = (obj: any): User => {
    function generateUserName(userObj: UserDetails) {
        const { firstName, lastName, email } = userObj;

        if (lastName && firstName) {
            return `${lastName}, ${firstName}`;
        }

        if (lastName || firstName) {
            return lastName || firstName;
        }

        return email;
    }

    return obj
        ? {
              emailVerified: obj.emailVerified,
              email: obj.email,
              username: generateUserName(obj),
              roles: obj.roles.split(','),
              groups: obj.groups,
              tenantKey: obj.tenantKey,
              customerId: obj.customerId,
              // this parameter helps us find matching users between mcconnect/okta and GET/users response
              userId: obj.userId,
              firstName: obj.firstName,
              lastName: obj.lastName,
              landlordId: obj.landlordId,
              tableauToken: obj.tableauToken
          }
        : {
              email: '',
              emailVerified: false,
              username: '',
              roles: [],
              groups: '',
              tenantKey: '',
              customerId: '',
              landlordId: '',
              userId: '',
              firstName: '',
              lastName: '',
              tableauToken: ''
          };
};

export const getAccessTokenDecoded = async () => {
    const accessToken = sessionStorage.getItem(AUTH_ACCESS_TOKEN) ?? sessionStorage.getItem(AUTH_REFRESH_TOKEN);
    return jwtDecode<any>(accessToken || '{}');
};
